import ProfileIcon from "../../../assets/images/ProfileIcon";
import {
  Constants,
  pageRouteConstants,
  StaffListConstants,
  StafflistConstants,
  UserStatus,
  UserStatusAction,
} from "../../../constants/constants";
import "./Staflist.css";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../store/store";
import { fetchStaffListAsync } from "../../../store/thunks/staffListThunk";
import { updateUserStatusAsync } from "../../../store/thunks/userThunk";
import {
  resetUpdateStatusErrorMsg,
  resetStatus,
  validatePendingStaffData,
} from "../../../store/slices/validatePendingStaffSlice";
import { STATUS, resetUserStatus } from "../../../store/slices/userDetailslice";
import PopupModal from "../../common/PopupModal";
import PopupModalWithCancelButton from "../../common/PopupModalWithCancelButton";
import ApproveIcon from "../../../assets/images/ApproveIcon";
import RejectIcon from "../../../assets/images/RejectIcon";
import { UserStatusRequestObj } from "./StaffListComponent";
import { useState, useEffect } from "react";
import Loader from "../../common/styles/Loader";
import LoaderPopupModel from "../../common/LoaderPopup";
import TooltipIcon from "../../../assets/images/TooltipIcon";
import { readFromLocalStorage } from "../../../utils/DataEncryption";
import BackIcon from "../../../assets/images/BackIcon";
type ApproveRejectActionsProps = {
  isFromDealer: boolean;
  data: any;
  updateUserStatus: (
    status: string,
    userId: string,
    toDealerId: string
  ) => void;
};
const ConflictStaffList = ({ statusKey }: any) => {
  const [popUpMsg, setPopUpMsg] = useState("");
  const [userStatusObj, setUserStatusObj] =
    useState<UserStatusRequestObj | null>(null);
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();

  const staffCount: any | null = useSelector(
    (state: RootState) => state.staffCount.staffCount
  );
  const totalCount = staffCount?.totalStaff;
  const [currentPage, setCurrentPage] = useState(0);
  const itemsPerPage = 10;
  const [indexOfFirstItem, setindexOfFirstItem] = useState(1);
  const [activePage, setActivePage] = useState(1);
  const [showConfirmationDialog, setConfirmationDialog] = useState(false);
  const [showPostConfirmationDialog, setPostConfirmationDialog] =
    useState(false);
  const indexOfLastItem = activePage * itemsPerPage;

  useEffect(() => {
    dispatch(
      fetchStaffListAsync({
        pageNumber: currentPage,
        rowsPerPage: itemsPerPage,
        key: UserStatus.CONFLICT,
      })
    );
  }, [dispatch, currentPage, statusKey]);

  const staffList: any = useSelector((state: RootState) => state.staffListData);
  const pendingStaff: validatePendingStaffData = useSelector(
    (state: RootState) => state.validatePendingStaffData
  );

  const updateUserStatus = async (
    status: string,
    userId: string,
    toDealerId: string
  ) => {
    if (status === UserStatusAction.CONFLICT_APPROVE) {
      setPopUpMsg(
        `${StaffListConstants.ConflictApproveConfimationMessage} ${toDealerId}`
      );
    } else if (status === UserStatusAction.CONFLICT_REJECT) {
      setPopUpMsg(StaffListConstants.ConflictRejectConfimationMessage);
    } else {
      setPopUpMsg(StaffListConstants.RejectConfirmationMessage);
    }
    setUserStatusObj({ status, userId });
    setConfirmationDialog(true);
  };

  const approveUser = async () => {
    setConfirmationDialog(false);
    if (userStatusObj?.status === UserStatusAction.CONFLICT_APPROVE) {
      setPopUpMsg(StaffListConstants.ApprovedSuccessMessage);
    } else {
      setPopUpMsg(StaffListConstants.RejectedSuccessMessage);
    }
    await dispatch(updateUserStatusAsync(userStatusObj));
  };

  useEffect(() => {
    if (pendingStaff?.updateStatus === STATUS.FAILED) {
      setPostConfirmationDialog(true);
      setPopUpMsg(StaffListConstants.APIErrorMessage);
    }
    if (pendingStaff?.updateStatus === STATUS.SUCCESS) {
      setPostConfirmationDialog(true);
    }
  }, [pendingStaff?.updateStatus, dispatch, currentPage]);

  const handleNextPage = () => {
    if (currentPage < Math.ceil(totalCount / itemsPerPage)) {
      setCurrentPage((prevPage) => prevPage + 1);
      setActivePage((prevPage) => prevPage + 1);
      setCurrentPage(currentPage + 1);
      setindexOfFirstItem(indexOfFirstItem + itemsPerPage);
    }
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setindexOfFirstItem(indexOfFirstItem - itemsPerPage);
      setCurrentPage((prevPage) => prevPage - 1);
      setActivePage((prevPage) => prevPage - 1);
    }
  };
  const closeModal = () => {
    setPopUpMsg("");
    setPostConfirmationDialog(false);
    setConfirmationDialog(false);
    dispatch(resetStatus());
    dispatch(resetUserStatus());
    dispatch(resetUpdateStatusErrorMsg());
  };
  const errorMsg = useSelector(
    (state: RootState) => state.validatePendingStaffData.updateStatusErrorMsg
  );
  return (
    <div className="bg-dashboardBackground text-white h-[100vh] pb-10">
      <div className="flex ">
        <div className="p-0 md:p-0 lg:p-6 StaffList text-black  w-full  ">
          <div
            data-testid="backButton"
            onClick={() => {
              navigate(pageRouteConstants.dashBoardRoute); // Navigate to the dashboard route
            }}
            className="my-2 md:mt-0 bg-primary w-[24px] h-[24px] flex items-center justify-center cursor-pointer mr-3  md:ml-0 rounded-lg"
          >
            <BackIcon />
          </div>
          <div>{StafflistConstants.ConflictStaffList}</div>

          <div className="h-[650px] w-full  overflow-hidden overflow-y-auto ">
            {pendingStaff?.loading ? (
              <Loader />
            ) : (
              <>
                <div className="block lg:hidden">
                  {staffList.staffList?.data.map((data: any, index: any) => {
                    let isFromDealer =
                      readFromLocalStorage("dealerId") ===
                      data?.conflictDetails?.fromDealer
                        ? true
                        : false;
                    return (
                      <div
                        key={index}
                        className="bg-white shadow-md rounded-xl p-4  mt-4 cursor-pointer hover:shadow-lg border border-gray-300"
                        onClick={() => navigate(`/StaffDetail/${data?.id}`)}
                      >
                        {/* Name */}
                        <div className="flex justify-between items-start ">
                          <div className="flex items-center gap-3 mb-3">
                            {data?.profilePhotoUrl ? (
                              <img
                                className="h-10 w-10 rounded-full object-cover"
                                src={data.profilePhotoUrl}
                                alt="profile photo"
                              />
                            ) : (
                              <ProfileIcon />
                            )}
                            <div>
                              <div className="staffName text-primary">
                                {data?.firstName}
                              </div>
                              <div className="text-gray-600 label mb-3">
                                {data?.baseRoles?.map(
                                  (roleData: any, index: number) => (
                                    <span key={index}>
                                      {roleData?.role?.name}
                                      {index !== data.baseRoles.length - 1 &&
                                        ", "}
                                    </span>
                                  )
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="flex justify-between items-start ">
                          <div className="flex flex-col  mb-3">
                            <div className={` label  text-black`}>
                              {StafflistConstants.CreatedDate}
                            </div>

                            <div className={`text-black employeeId`}>
                              {data?.createdAt}
                            </div>
                          </div>
                          {/* EKYC Status & User Status */}
                          <div className="flex justify-start items-start gap-2">
                            <div>
                              <div className=" label text-black ">
                                PhoneNumber
                              </div>
                              <div className="text-black employeeId mb-3">
                                {data?.primaryPhoneNumber}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="flex justify-start items-start ">
                          <div className="flex items-center gap-3 mb-3">
                            <div>
                              <div className="label text-black ">
                                {StafflistConstants.ConflictingReason}
                              </div>
                              <div className={`text-black employeeId`}>
                                {data.conflictDetails?.reason ?? ""}
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Add Role & Actions */}
                        <div className="flex justify-end items-center">
                          <div className="flex gap-3">
                            <div className="flex items-center justify-center">
                              <ApproveRejectActions
                                isFromDealer={isFromDealer}
                                data={data}
                                updateUserStatus={updateUserStatus}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
                <div className="hidden lg:block">
                  <table className=" min-w-full mt-6">
                    <thead className="bg-sideMenubackground text-black  h-[72px]  ">
                      <tr>
                        <th className=" text2 w-1/12 pl-8 text-start ">
                          {StafflistConstants.StaffList}
                        </th>
                        <th className=" text2 w-1/12 ">
                          {StafflistConstants.Baserole}
                        </th>
                        <th className=" text2 w-1/12  ">
                          {StafflistConstants.CreatedDate}
                        </th>
                        <th className=" text2 w-1/12    ">
                          {StafflistConstants.ConflictingReason}
                        </th>
                        <th className=" text2 w-1/12 text-center ">
                          {Constants.Actions}
                        </th>
                      </tr>
                    </thead>
                    <tbody className="bg-whiteColor w-full">
                      {staffList.staffList?.data.map(
                        (data: any, index: any) => {
                          let isFromDealer =
                            readFromLocalStorage("dealerId") ===
                            data?.conflictDetails?.fromDealer
                              ? true
                              : false;
                          return (
                            <>
                              <tr
                                data-testid="staff-row"
                                key={index}
                                className="cursor-pointer "
                                onClick={(e) => {
                                  e.stopPropagation();
                                  navigate(`/StaffDetail/${data.id}`);
                                }}
                              >
                                <td className="py-4  ">
                                  <div className=" items-center justify-start pl-4 flex">
                                    <div className=" mr-2">
                                      {data?.profilePhotoUrl ? (
                                        <img
                                          className="h-10 w-10 rounded-full object-cover"
                                          src={data.profilePhotoUrl}
                                          alt="profile photo"
                                        />
                                      ) : (
                                        <ProfileIcon />
                                      )}
                                    </div>
                                    <div className="">
                                      <div className="text3 text-borderColor">
                                        {data?.firstName}
                                      </div>
                                      <div className="text6">{data?.email}</div>
                                      <div className="text6 mt-1 ">
                                        {data?.primaryPhoneNumber}
                                      </div>
                                    </div>
                                  </div>
                                </td>
                                <td>
                                  <div className="text3 text-center text-borderColor">
                                    {data?.baseRoles.map(
                                      (roleData: any, index: number) => {
                                        return (
                                          <div key={index}>
                                            {roleData?.role?.name}
                                            {index !==
                                              data.baseRoles.length - 1 && ","}
                                          </div>
                                        );
                                      }
                                    )}
                                  </div>
                                </td>
                                <td>
                                  <div className=" text6 text-primary text-center">
                                    {data.createdAt}
                                  </div>
                                </td>
                                <td>
                                  <div className=" text6 text-primary text-center">
                                    {data.conflictDetails?.reason ?? ""}
                                  </div>
                                </td>

                                <td onClick={(e) => e.stopPropagation()}>
                                  <div className="flex items-center justify-center">
                                    <ApproveRejectActions
                                      isFromDealer={isFromDealer}
                                      data={data}
                                      updateUserStatus={updateUserStatus}
                                    />
                                  </div>
                                </td>
                              </tr>
                            </>
                          );
                        }
                      )}
                    </tbody>
                  </table>
                </div>
              </>
            )}
            {staffList?.staffList?.totalCount > 10 && (
              <div className="bg-primary py-3">
                <div className="flex justify-end pr-8 ">
                  <div className=" flex border border-black px-2 py-1 rounded-lg bg-whiteColor">
                    <button
                      disabled={currentPage === 1}
                      onClick={handlePrevPage}
                      style={{
                        fontSize: "18px",
                        color: "#183883",
                      }}
                    ></button>
                  </div>
                  <div className="text-[16px] text-white px-3 pt-1">
                    {indexOfFirstItem} - {indexOfLastItem}
                  </div>

                  <div className=" flex border border-black px-2 py-1 rounded-lg bg-whiteColor">
                    <button
                      disabled={
                        currentPage === Math.ceil(totalCount / itemsPerPage)
                      }
                      onClick={handleNextPage}
                      style={{
                        fontSize: "18px",
                        color: "#183883",
                      }}
                    >
                      {">"}
                    </button>
                  </div>
                </div>
              </div>
            )}
            {showConfirmationDialog && (
              <PopupModalWithCancelButton
                popUpTitle={StaffListConstants.AreYouSure}
                popUpMsg={popUpMsg}
                isOpen={showConfirmationDialog}
                onOkay={approveUser}
                onCancel={closeModal}
              />
            )}
            {showPostConfirmationDialog && (
              <PopupModal
                popUpTitle={errorMsg == null ? popUpMsg : errorMsg}
                popUpMsg={StaffListConstants.UserApprovedDescription}
                buttonText={StaffListConstants.Okay}
                isOpen={showPostConfirmationDialog}
                onClose={() => {
                  closeModal();
                  dispatch(
                    fetchStaffListAsync({
                      pageNumber: currentPage,
                      rowsPerPage: itemsPerPage,
                      key: statusKey,
                    })
                  );
                }}
                isSucessMessage={errorMsg == null ? true : false}
              />
            )}
            {pendingStaff?.updateStatus === STATUS.LOADING && (
              <LoaderPopupModel
                isOpen={pendingStaff?.updateStatus === STATUS.LOADING}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

const ApproveRejectActions = ({
  isFromDealer,
  data,
  updateUserStatus,
}: ApproveRejectActionsProps) => (
  <div className="flex justify-center gap-4">
    {isFromDealer && (
      <div
        data-testid="approveUser"
        className="has-tooltip"
        onClick={() => {
          updateUserStatus(
            UserStatusAction.CONFLICT_APPROVE,
            data.id,
            data.conflictDetails.toDealer
          );
        }}
      >
        <span className="tooltip relative text-xs  rounded-lg px-5 py-2 bg-white text-black staffListDownloadCheckbox mt-10">
          <div className="absolute bottom-[-15px] left-9 z-100">
            <TooltipIcon />
          </div>
          {Constants.ApproveUser}
        </span>
        <ApproveIcon bgColor={"#ECF5EE"} iconColor={"#449F52"} />
      </div>
    )}
    <div
      data-testid="rejectUser"
      className="has-tooltip"
      onClick={() => {
        updateUserStatus(
          isFromDealer
            ? UserStatusAction.CONFLICT_REJECT
            : Constants.RejectUser,
          data.id,
          data.conflictDetails?.toDealerId
        );
      }}
    >
      <span className="tooltip relative text-xs  rounded-lg px-5 py-2 bg-white text-black staffListDownloadCheckbox mt-10">
        <div className="absolute bottom-[-15px] left-9 z-100">
          <TooltipIcon />
        </div>
        {Constants.UserReject}
      </span>
      <RejectIcon />
    </div>
  </div>
);

export default ConflictStaffList;
